"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  SET_APP_ROOT: true,
  setAppRoot: true,
  SET_APP_MODE: true,
  setAppMode: true,
  PAGE_IS_INIT: true,
  initPage: true,
  MODAL_OPEN: true,
  openModal: true,
  closeModal: true,
  CHANGE_MODE: true,
  changeMode: true,
  SET_EXPECT_OFFLINE: true,
  setExpectOffline: true,
  FOCUS_ELEMENT: true,
  focusElement: true,
  DOWNLOAD_FILE: true,
  downloadFile: true,
  REDIRECT: true,
  redirect: true,
  MAIN_TAB_CHANGE: true,
  SET_PACKAGEJSON_DATA: true,
  setPackageJsonData: true,
  INITIALIZE: true,
  initialize: true
};
exports.initialize = exports.INITIALIZE = exports.setPackageJsonData = exports.SET_PACKAGEJSON_DATA = exports.MAIN_TAB_CHANGE = exports.redirect = exports.REDIRECT = exports.downloadFile = exports.DOWNLOAD_FILE = exports.focusElement = exports.FOCUS_ELEMENT = exports.setExpectOffline = exports.SET_EXPECT_OFFLINE = exports.changeMode = exports.CHANGE_MODE = exports.closeModal = exports.openModal = exports.MODAL_OPEN = exports.initPage = exports.PAGE_IS_INIT = exports.setAppMode = exports.SET_APP_MODE = exports.setAppRoot = exports.SET_APP_ROOT = void 0;

var _createAction = require("./create-action");

var _getActionName = require("../utils/get-action-name");

var _constants = require("../../constants");

var _actions = require("../locales/actions");

Object.keys(_actions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _actions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _actions[key];
    }
  });
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SET_APP_ROOT = (0, _getActionName.getActionName)('SET_APP_ROOT', _constants.MODULE_NAME);
/**
 * An application is usually located under specific root path. In most cases on
 * SkyBase it is located under `/ui/` root. On the boostrapping of the application
 * we should call this action to specify root of application, so all ajax
 * requests will be properly called and static files will be properly gethered.
 *
 * @name skybase-core.base.actions#setAppRoot
 *
 * @method
 * @param  {appRoot} url specifies where is the root of your application
 * @return {Action} will return the appRoot change action object
 */

exports.SET_APP_ROOT = SET_APP_ROOT;

var setAppRoot = function setAppRoot(appRoot) {
  return (0, _createAction.createAction)(SET_APP_ROOT, {
    appRoot: appRoot
  });
};

exports.setAppRoot = setAppRoot;
var SET_APP_MODE = (0, _getActionName.getActionName)('SET_APP_MODE', _constants.MODULE_NAME);
exports.SET_APP_MODE = SET_APP_MODE;

var setAppMode = function setAppMode(mode) {
  return (0, _createAction.createAction)(SET_APP_MODE, {
    mode: mode
  });
};

exports.setAppMode = setAppMode;
var PAGE_IS_INIT = (0, _getActionName.getActionName)('PAGE_IS_INIT', _constants.MODULE_NAME);
exports.PAGE_IS_INIT = PAGE_IS_INIT;

var initPage = function initPage(pageId) {
  var isInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return function (dispatch) {
    return dispatch((0, _createAction.createAction)(PAGE_IS_INIT, {
      pageId: pageId,
      isInit: isInit
    }));
  };
};

exports.initPage = initPage;
var MODAL_OPEN = (0, _getActionName.getActionName)('MODAL_OPEN', _constants.MODULE_NAME);
/**
 * To Open modal dialogs you will use openModal() dialog.
 *
 * @name skybase-core.base.actions#openModal
 *
 * @method
 * @param  {String} modalId it should be array of of parameter object with at least 'id' and 'value'
 * @param  {Object} data - data you want to pass to modal reducers, it is generic
 * object, because different modals needs to handle different data.
 * @return {Action} Action object
 */

exports.MODAL_OPEN = MODAL_OPEN;

var openModal = function openModal(modalId, data) {
  return (0, _createAction.createAction)(MODAL_OPEN, _objectSpread({
    modalId: modalId
  }, data));
};
/**
 * You will use this generic action to close modal window. The idea behind is very
 * simple, we will just specify new modal with id "null" and therefore every active
 * modal will be closed
 *
 * @name skybase-core.base.actions#closeModal
 *
 * @method
 * @return {Action} Action object
 */


exports.openModal = openModal;

var closeModal = function closeModal() {
  return openModal(null);
};
/**
 * ChangeMode action needs to have specified the mode Id
 *
 * @typedef ActionType.ChangeMode
 *
 * @property {String} modeId - The modeId
 */


exports.closeModal = closeModal;
var CHANGE_MODE = (0, _getActionName.getActionName)('CHANGE_MODE', _constants.MODULE_NAME);
/**
 * Change the mode of the device.
 *
 * @name skybase-core.base.actions#changeMode
 *
 * @method
 * @param  {String} modeId - we have different mode ids. Use NORMAL, UPDATE, OFFLINE
 * @return {Action} Action object
 */

exports.CHANGE_MODE = CHANGE_MODE;

var changeMode = function changeMode(modeId) {
  return (0, _createAction.createAction)(CHANGE_MODE, {
    modeId: modeId
  });
};
/**
 * Sets true or false if the device is expected to be offline, this may be run by a feature
 *
 * @typedef
 *
 * @property {Boolean} expected - Whether or not the device is expected to be offline
 */


exports.changeMode = changeMode;
var SET_EXPECT_OFFLINE = (0, _getActionName.getActionName)('SET_EXPECT_OFFLINE', _constants.MODULE_NAME);
/**
 * sets true or false if the device is expected to be offline, this may be run by a feature
 *
 * @name skybase-core.base.actions#setExpectOffline
 *
 * @method
 * @param  {Boolean} expected - Whether or not the device is expected to be offline
 * @return {Action} Action object
 */

exports.SET_EXPECT_OFFLINE = SET_EXPECT_OFFLINE;

var setExpectOffline = function setExpectOffline(expected) {
  return (0, _createAction.createAction)(SET_EXPECT_OFFLINE, {
    expected: expected
  });
};

exports.setExpectOffline = setExpectOffline;
var FOCUS_ELEMENT = (0, _getActionName.getActionName)('FOCUS_ELEMENT', _constants.MODULE_NAME);
/**
 * Action which is responsible to focus you on a particular place in a application.
 * E.g. when you want to focus on settings page to particular textbox, it should
 * be possible to navigate you to that textbox from every place of you application
 *
 * @name skybase-core.base.actions#focusElement
 *
 * @method
 * @param  {String} selector
 * @return {Action} Action object
 */

exports.FOCUS_ELEMENT = FOCUS_ELEMENT;

var focusElement = function focusElement(selector) {
  return (0, _createAction.createAction)(FOCUS_ELEMENT, {
    selector: selector
  });
};

exports.focusElement = focusElement;
var DOWNLOAD_FILE = (0, _getActionName.getActionName)('DOWNLOAD_FILE', _constants.MODULE_NAME);
exports.DOWNLOAD_FILE = DOWNLOAD_FILE;

var downloadFile = function downloadFile(url, saveAsFileName) {
  return (0, _createAction.createAction)(DOWNLOAD_FILE, {
    url: url,
    saveAsFileName: saveAsFileName
  });
};

exports.downloadFile = downloadFile;
var REDIRECT = (0, _getActionName.getActionName)('REDIRECT', _constants.MODULE_NAME);
exports.REDIRECT = REDIRECT;

var redirect = function redirect(url) {
  return (0, _createAction.createAction)(REDIRECT, {
    url: url
  });
};

exports.redirect = redirect;
var MAIN_TAB_CHANGE = (0, _getActionName.getActionName)('MAIN_TAB_CHANGE', _constants.MODULE_NAME);
exports.MAIN_TAB_CHANGE = MAIN_TAB_CHANGE;
var SET_PACKAGEJSON_DATA = (0, _getActionName.getActionName)('SET_PACKAGEJSON_DATA', _constants.MODULE_NAME);
exports.SET_PACKAGEJSON_DATA = SET_PACKAGEJSON_DATA;

var setPackageJsonData = function setPackageJsonData(data) {
  return (0, _createAction.createAction)(SET_PACKAGEJSON_DATA, {
    data: data
  });
};

exports.setPackageJsonData = setPackageJsonData;
var INITIALIZE = (0, _getActionName.getActionName)('INITIALIZE', _constants.MODULE_NAME);
exports.INITIALIZE = INITIALIZE;

var initialize = function initialize() {
  return (0, _createAction.createAction)(INITIALIZE, {});
};

exports.initialize = initialize;
//# sourceMappingURL=actions.js.map